var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgEditIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.33335 2.06542L1.8976 9.46548C1.58167 9.81376 1.3685 10.2428 1.28181 10.705L0.885381 13.5263C0.837581 13.746 0.845808 13.9743 0.909306 14.19C0.972805 14.4058 1.08954 14.6021 1.24876 14.7609C1.40799 14.9198 1.6046 15.036 1.8205 15.099C2.03641 15.1619 2.26468 15.1696 2.48432 15.1212L5.32146 14.7248C5.78527 14.6388 6.21641 14.4266 6.56758 14.1117L14.0033 6.7116C15.2785 5.44302 15.8943 3.96168 14.0033 2.08656C12.1123 0.211435 10.6218 0.787583 9.33335 2.06542Z",
    stroke: "#1890FF",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.27222 3.12521C8.58636 4.23091 9.17976 5.23715 9.99532 6.04716C10.8109 6.85716 11.8212 7.44367 12.929 7.75026",
    stroke: "#1890FF",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_176"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.0608,
    height: 16,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEditIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/edit-icon.7b3810dfb201dd02ad9c81ae1dcc65d6.svg";